/*
 | Desde qué página de la web se llega al carrito.
 |
 | Al pulsar un enlace (o enviar un formulario) hacia el carrito de
 | core.hostsuar.com, se le añade `entry` con el host y la ruta de esta página y,
 | si a esta página se llegó desde fuera, `entry_source` con ese dominio. El
 | carrito lo guarda con el pedido (RememberCheckoutEntry y CheckoutEntry) y
 | `web:checkout-entries` lo cruza con lo pagado.
 |
 | No se guarda nada en el navegador: ni cookies ni almacenamiento local. El
 | navegador no lo diría por su cuenta, porque entre dos subdominios solo manda
 | el origen de la página, sin la ruta.
 */
const OWN = /(^|\.)hostsuar\.(com|local)$/;

export function entryParameters(location, referrer) {
    const parameters = { entry: location.host + location.pathname.replace(/\/$/, "") };
    let source = "";

    try {
        source = referrer ? new URL(referrer).hostname : "";
    } catch (error) {
        source = "";
    }

    if (source && !OWN.test(source)) {
        parameters.entry_source = source;
    }

    return parameters;
}

export function isCartUrl(url, location) {
    return url.host !== location.host && OWN.test(url.hostname) && /^\/cart(\/|$)/.test(url.pathname);
}

export function withEntry(href, location, referrer) {
    const url = new URL(href, location.href);

    if (!isCartUrl(url, location) || url.searchParams.has("entry")) {
        return href;
    }

    for (const [key, value] of Object.entries(entryParameters(location, referrer))) {
        url.searchParams.set(key, value);
    }

    return url.toString();
}

export default function registerCheckoutEntry() {
    document.addEventListener(
        "click",
        (event) => {
            const link = event.target instanceof Element ? event.target.closest("a[href]") : null;

            if (link) {
                link.href = withEntry(link.href, window.location, document.referrer);
            }
        },
        true,
    );

    document.addEventListener(
        "submit",
        (event) => {
            const form = event.target instanceof HTMLFormElement ? event.target : null;

            if (!form || !isCartUrl(new URL(form.action, window.location.href), window.location) || form.querySelector('[name="entry"]')) {
                return;
            }

            for (const [key, value] of Object.entries(entryParameters(window.location, document.referrer))) {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }
        },
        true,
    );
}
